import React from 'react'
import { createPortal } from 'react-dom'
import { useDarkMode } from '../../context/DarkModeContext'

// Shown when the plan's mailbox or template limit is reached. Rendered into
// document.body because the phone settings view clips fixed-position children.
const LimitReachedModal = ({ title, message, onClose }) => {
	const { isDarkMode } = useDarkMode()
	const isLight = !isDarkMode

	return createPortal(
		<>
			<div className="fixed inset-0 bg-black transition-opacity duration-300 opacity-50 z-[90]" onClick={onClose}></div>
			<div className="fixed inset-0 flex items-center justify-center px-4 -mt-32 z-[100] pointer-events-none">
				<div
					role="dialog"
					aria-modal="true"
					aria-label={title}
					className={`pointer-events-auto rounded-lg p-8 w-full max-w-[32rem] min-h-[15rem] relative ${
						isLight
							? 'bg-white ring-1 ring-gray-200 shadow-lg'
							: 'bg-[#15202b] ring-1 ring-white/10 shadow-[0_0_15px_rgba(59,130,246,0.1)]'
					}`}
				>
					<div className="flex justify-between items-start">
						<h2 className={`text-2xl font-bold ${isLight ? 'text-gray-900' : 'text-white'}`}>{title}</h2>
						<button
							onClick={onClose}
							aria-label="Close"
							className={`-mt-1 ${isLight ? 'text-gray-500 hover:text-gray-700' : 'text-gray-400 hover:text-gray-300'}`}
						>
							<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
							</svg>
						</button>
					</div>
					<p className={`mt-6 mb-16 text-lg ${isLight ? 'text-gray-700' : 'text-gray-300'}`}>{message}</p>
					<div className="absolute bottom-8 right-8">
						<button
							onClick={onClose}
							className={`px-5 py-2.5 rounded-lg transition-colors duration-150 ease-in-out text-sm font-semibold ${
								isLight ? 'bg-gray-100 text-gray-900 hover:bg-gray-200' : 'bg-[#263340] text-white hover:bg-[#2c3b4a]'
							}`}
						>
							Close
						</button>
					</div>
				</div>
			</div>
		</>,
		document.body,
	)
}

export default LimitReachedModal
